<script setup lang="ts">
import {managementModules, type Module} from '@/common/components/bltSideNav/managementAppsEnum'
import {computed} from 'vue'
import type IFeature from '@/common/models/IFeature'
import {useRoute} from 'vue-router'
import { getManagementAppsFeatureEnabledService } from './managementAppsFeatureEnabledService'

const props = defineProps<{
  activeFeatures: Array<IFeature>
}>()

const emits = defineEmits<{
  (e: 'click', route: string): void
}>()

const route = useRoute()

const managementModulesFilteredByLaunchDarkly = computed(() =>
  managementModules.filter(module => getManagementAppsFeatureEnabledService().get(module.route).value))

const activeFeaturesFeatureCodes = computed(() => props.activeFeatures.map((feature) => feature.featureCode))

const sortedModulesFilteredByTheFeatureCode = computed(() =>
  managementModulesFilteredByLaunchDarkly.value
    .filter((module) => activeFeaturesFeatureCodes.value.includes(module.featureCode))
    .sort((a, b) => (a.name > b.name ? 1 : -1))
)

const routeIsActive = (moduleRoute: string) => {
  return route.matched
    .map((x) => x.name)
    .includes(moduleRoute)
}
</script>
<template>
  <div
    v-for="module in sortedModulesFilteredByTheFeatureCode"
    :key="module.name">
    <jha-nav class="side-nav-jha-nav new">
      <a
        style="padding-left: 58px"
        :key="module.name"
        :class="routeIsActive(module.route) ? 'active' : 'nonActive'"
        :active="routeIsActive(module.route) ? 'true' : null"
        @click="emits('click', module.route)"
        tabindex="0"
        role="button"
        @keydown.enter="emits('click', module.route)">
        {{ module.name }}
      </a>
    </jha-nav>
  </div>
</template>
